import { PermissionT } from "../types";

export const earningsView = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "earnings_view");
  return !!p;
};

export default earningsView;
